import { createModel } from "@rematch/core";
import { CustomerGroupFilterState, PolygonDensityState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, multiRequest, signoutIfUnauthorized } from "./utilities";

const initialState: PolygonDensityState = {
  loading: true,
  polygons: [],
  pending: null,
};

export const polygonDensity = createModel<RootModel>()({
  state: initialState as PolygonDensityState,
  reducers: {
    fetchPending(state, requestId: string) {
      return multiRequest.updatePending(state, requestId);
    },
    fetchSuccess(
      state,
      payload: Partial<PolygonDensityState>,
      requestId: string
    ) {
      return multiRequest.updateSuccess(payload, state, requestId);
    },
    fetchFail(state, requestId: string) {
      return multiRequest.updateFail(state, requestId);
    },
  },
  effects: (dispatch) => ({
    async fetchPolygonDensity(
      customerGroupFilter: CustomerGroupFilterState,
      rootState
    ) {
      const requestId = multiRequest.getRequestId();
      dispatch.polygonDensity.fetchPending(requestId);

      const token = checkToken(rootState, () =>
        dispatch.polygonDensity.fetchFail(requestId)
      );
      if (!token) return;

      try {
        const polygonDensityResult = await api.fetchPolygonDensity(
          token,
          customerGroupFilter
        );
        dispatch.polygonDensity.fetchSuccess(polygonDensityResult, requestId);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.polygonDensity.fetchFail(requestId);
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/polygonDensity.ts